import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Dispatch, iRootState } from "src/rematch/store";
import { Action } from "@rematch/core";

export interface ILanguageSelectorProps {
  changeLanguage: (language: string) => Action<string,void>;
  updateTextFields: () => Action<void,void>;
  languages: string[];
}

const LanguageSelector = (props: ILanguageSelectorProps) => {
  const { i18n } = useTranslation();
  const languageOptions = [];

  const changeLanguage = (language: string) => {
    props.changeLanguage(language);
    i18n.changeLanguage(language);
    props.updateTextFields();
  }

  //Change en-US to en or fi-FI to fi
  if(!props.languages.includes(i18n.language)) {
    const shortLang = i18n.language.substring(0,2);
    if(props.languages.includes(shortLang)) {
      changeLanguage(shortLang);
    } else {
      changeLanguage(props.languages[0]);
    }
  }

  for (const language of i18n.languages) {
    languageOptions.push(<option key={language} value={language}>{language}</option>);
  }
  return (
    <select onChange={(e) => changeLanguage(e.target.value)}>
      {languageOptions}
    </select>);
};

const mapState = (state: iRootState) => ({
  language: state.common.language,
  languages: state.common.languages,
});

const mapDispatch = (dispatch: Dispatch) => ({
  changeLanguage: (language: string) => dispatch.common.changeLanguage(language),
  updateTextFields: dispatch.items.updateTextFields,
});

export default connect(mapState, mapDispatch)(LanguageSelector);
